// material-ui
import { Box } from '@mui/material';

import {
    Tooltip,
    IconButton,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import DeleteAlert from './DeleteAlert';

// third party
import moment from 'moment';

const SportsTypeList = ({ rows, setReload, handleOpen }) => {

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ pl: 3 }}>#</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Value</TableCell>
                                <TableCell>created At</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                rows.map((row, index) =>
                                    <TableRow hover key={index}>
                                        <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                        <TableCell>{row.display_name}</TableCell>
                                        <TableCell>{row.code}</TableCell>
                                        <TableCell>
                                            {moment(row.created_at).format('DD-MM-YYYY HH:mm:ss')}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'start', whiteSpace: 'nowrap' }}>
                                            <Tooltip placement="top" title="Edit">
                                                <IconButton
                                                    color="primary"
                                                    aria-label="edit"
                                                    size="large"
                                                    onClick={() => handleOpen(row.uuid)}
                                                >
                                                    <EditIcon sx={{ fontSize: '1.1rem' }} />
                                                </IconButton>
                                            </Tooltip>
                                            <DeleteAlert setReload={setReload} sportsTypeUuid={row.uuid} />
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </MainCard>
        </Box>
    );
};

export default SportsTypeList;
